module.exports = __webpack_public_path__ + "img/76.3174d245.webp";